<template>
	<div
		class="blue blain-form tooltip zip-input,
				tooltip-validation show-labels"
		@keydown.esc="close"
	>
		<label class="zip-input-label" for="stockStatusZip">
			ZIP Code
		</label>
		<div class="zip-container-new">
			<tool-tip
				v-if="zipInputError"
				:floating-tip="isMobile"
				:show="zipInputError != null"
				:text="zipInputError"
				width="180px"
				position="top"
			/>
			<input
				name="stockStatusZip"
				placeholder="Enter your ZIP code"
				:class="`form-control zipfield tooltipstered ${validationIcon}`"
				v-model="value"
				v-focus
				type="number"
				@input="inputHandler"
				@keydown.enter="handleSubmit"
			/>

			<div v-if="isMobile" class="submit-btn-group">
				<b-button
					class="submit-btn-group__input"
					color='blue'
					variant='secondary'
					minimal
					:disabled="shippingLoading"
					@click="close"
					@keydown.enter="close"
				>
					Cancel
				</b-button>
				<b-button
					class="submit-btn-group__input"
					color='blue'
					minimal
					:loading="shippingLoading"
					:disabled="loading"
					@click.stop="handleSubmit"
				>
					Submit
				</b-button>
			</div>
			
			<div v-else class="submit-btn-group">
				<b-button
					color='blue'
					minimal
					:loading="shippingLoading"
					:disabled="loading"
					@click.stop="handleSubmit"
				>
					Submit
				</b-button>
				<b-button
					color='blue'
					variant='secondary'
					minimal
					:disabled="shippingLoading"
					@click="close"
					@keydown.enter="close"
				>
					Cancel
				</b-button>
			</div>
		</div>
	</div>
</template>

<script>
import BButton from 'JS/components/BButton.vue';
import ToolTip from 'JS/components/ToolTip.vue';
import { CartUpdateResolutionType } from 'JS/types/Order';

export default {
	name: 'ExpandableZipAreaNew',
	components: { BButton, ToolTip },
	directives: {
		'focus': focus
	},
	props: {
		loading: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			zipInputError: null,
			zipLoading: false,
			untouched: true,
			value: this.initValue,
		};
	},
	computed: {
		shippingLoading() {
			return this.zipLoading || this.$store.state.shippingLoading;
		},
		isMobile() {
			return this.$mq === 'pdp-mobile';
		},
		errorShow() {
			return this.error ? true : false;
		},
		validationIcon() {
			if (this.untouched) return '';
			return this.value && this.value.length === this.maxLength && !this.errorShow
				? 'valid'
				: 'error';
		}
	},
	methods: {
		clearError() {
			this.zipInputError = null;
		},
		close() {
			this.clearError();
			return this.$emit('close');
		},
		async handleSubmit() {
			const zip = this.value;
			this.untouched = false;
			if (!zip || zip.length < 5) return this.zipInputError = 'Please enter a 5 digit ZIP code';

			this.zipLoading = true;
			const response = await this.$store.dispatch('updateShipToZip', zip);
			this.zipLoading = false;
			if (response.resolutionType === CartUpdateResolutionType.InvalidZip) {
				this.zipInputError = 'Invalid ZIP code';
				return;
			}
			this.close(); 
		},
		inputHandler(event) {
			if (
				event.target.value < 0
					|| event.data === '-'
					|| event.data === '+'
					|| event.data === '.'
			) {
				const newVal = this.value.replace(event.data, '');
				event.target.value = this.value = newVal;
			}
			if (event.target.value.length >= this.maxLength) {
				const prevValue = event.target.value.toString().slice(0, this.maxLength);
				event.target.value = this.value = prevValue;
				this.clearError();
			}
		},
	},
	watch: {
		initValue(newVal, oldVal) {
			if (newVal !== oldVal) this.value = newVal;
		}
	}
};
</script>

<style lang="less" scoped>
@import '../../../../less/_mixins';
.zip-container-new {
	width: 100%;
	justify-content: space-between;
	display: flex;
	align-items: center;
	flex-direction: column;
	gap: 10px;
	
	.tablet-and-up-styles({
		flex-direction: row;
		gap: 15px;
	});

	label.zip-input-label {
		color: #4C5271;
		font-size: 0.875rem;
		font-weight: 700;
	}

	.submit-btn-group {
		display: flex;
		flex-direction: row;
		width: 100%;
		gap: 10px;

		.tablet-and-up-styles({
			width: auto;
		});

		&__input {
			width: 100%;

		.tablet-and-up-styles({
			width: auto;
		});

		}
	}

	.right-section, .left-section {
		display: inline-flex;
	}
	.right-section {
		input {
			font-size: 16px;
			color: #666666;
		}
	}
	.left-section {
		padding: 10px;
		font-size: 12px;
		font-weight: bold;
		cursor: pointer;
		.fa-times {
			font-size: 14px;
		}
		.close-span {
			padding: 2px 0 0 5px;
		}
	}

	@media screen and (max-width: @tablet) {

	}

	@media screen and (max-width: @mobile) {
		.zip-container {
			max-width: 100%;
		}
		.right-section {
			input {
				font-size: 14px;
			}
		}
		.left-section {
			padding: 5px;
			font-size: 10px;
			.fa-times {
				font-size: 12px;
			}
		}
	}

	.zip-input {
		margin-bottom: 0;
	}
		.blain-form .form-control {
			font-size: 15px;
			height: auto;
			line-height: 1;
			padding: 8px 12px;
		}
		.inline-input-btn {
			font-size: 15px!important;
			position: absolute;
			top: 0;
			bottom: 0;
			right: 0;
		}
	.zipfield {
		border: 1px solid #656E96;
	}

	.zip-field-loader {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 32px 0;
		color: #4C5271;
		font-size: 1rem;
		font-weight: bold;

		svg {
			width: 18px;
			height: 18px;
			fill: #717BA9;
			margin-right: 8px;
			animation: spin 1.25s linear infinite;
		}

		@keyframes spin {
			0% {
				transform: rotate(0deg);
			}

			100% {
				transform: rotate(360deg);
			}
		}
	}

	@media screen and (max-width: @tablet) {
		.blain-form .form-control {
			font-size: 14px;
		}
	}
	@media screen and (max-width: @mobile) {
		.blain-form .form-control {
			font-size: 12px;
			height: auto;
			line-height: 1;
			padding: 5px 8px;
		}
		.inline-input-btn {
			font-size: 12px!important;
		}
	}
	@media screen and (max-width: @mobile-small) {
		.zip-input {
			min-width: 120px;
			max-width: 140px;
		}
	}
}
</style>